import React from "react";
import Text from "@/components/marketing/Text";
import Section from "@/components/marketing/Section";

interface CaseStudyHeaderProps {
    title: string;
    description: string;
    featuredImage: string;
    client: string;
    headquarter: string;
    founded: number;
}

const CaseStudyHeaderHightlighedInfo = ({ title, data}) => (
    <div className="flex flex-col p-6 md:p-7 lg:p-12 gap-2 border-b border-r-0 last:border-b-0 md:border-r md:border-b-0 last:border-r-0 border-silvermist-100">
        <Text weight="semibold" color="primary">{title}</Text>
        <Text color="secondary">{data}</Text>
    </div>
)

const CaseStudyHeader: React.FC<CaseStudyHeaderProps> = ({
    title = '',
    description = '',
    featuredImage = '',
    client = '',
    headquarter = '',
    founded = '',
}) => {
    return (
        <div className="w-full border-t border-silvermist-100">
            <div className="max-w-[1100px] mx-auto border-x border-silvermist-100">
                <Section contentWidth="content-xs" padding="p-none" className="border-x border-dashed border-silvermist-100">
                    <div className="gap-4 px-0 py-12 lg:px-12">
                        <Text color="secondary" size="sm" weight="semibold" className="uppercase tracking-wider">Case study</Text>
                        <Text as="h1" color="primary" weight="semibold" size="6xl" tracking="tight" className="max-w-[680px] leading-tighter">{title}</Text>
                    </div>
                </Section>
            </div>

            <div className="border-y border-silvermist-100">
                <Section padding="p-none" contentWidth="content-sm" className="border-x border-silvermist-100 !px-0">
                    <div className="p-2 bg-silvermist-50">
                        <img
                            src={featuredImage}
                            alt={client + " x Wolfia"}
                            className="w-full h-auto object-cover rounded-lg"
                        />
                    </div>
                </Section>
            </div>

            <Section contentWidth="content-sm" padding="p-none" className="grid grid-cols-1 !px-0 md:grid-cols-3 border-x border-b border-silvermist-100">
                <CaseStudyHeaderHightlighedInfo title="Description" data={description} />
                <CaseStudyHeaderHightlighedInfo title="Headquarter" data={headquarter} />
                <CaseStudyHeaderHightlighedInfo title="Founded" data={founded} />
            </Section>
        </div>
    )
}

export default CaseStudyHeader;